<gea-shop-wagtail-page [cmsPageId]="pageId"></gea-shop-wagtail-page>
